module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/a811a6ef7da423c90b33730728a2ed0c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Emerald/Emerald4.svg
// module id = xebo
// module chunks = 1